export const HOTKEYS = {
  assigneePicker: 'a',
  labelPicker: 'l',
  milestonePicker: 'm',
  projectPicker: 'p',
  issueTypePicker: 't',
  // Should be the same as in packages/issue-viewer/constants/hotkeys.ts
  developmentSection: 'd',
}
